/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Blog_Author_DescriptionInputs */

const en_blog_author_description = /** @type {(inputs: Blog_Author_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Articles by ${i?.name} on the Complete Athlete blog.`)
};

const pl_blog_author_description = /** @type {(inputs: Blog_Author_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Artykuły autorstwa ${i?.name} na blogu Complete Athlete.`)
};

/**
* | output |
* | --- |
* | "Articles by {name} on the Complete Athlete blog." |
*
* @param {Blog_Author_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_author_description = /** @type {((inputs: Blog_Author_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Author_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_author_description(inputs)
	return en_blog_author_description(inputs)
});